import { api } from "./axiosClient";
import type { EntityType } from "../types/entityType.types";

export const entityTypeApi = {
  searchEntityTypes: async (payload: any) => {
    const response = await api.post("/entityType/search", payload);
    return response.data;
  },

  createEntityType: async (data: Partial<EntityType>) => {
    const response = await api.post("/entityType/create", data);
    return response.data;
  },

  updateEntityType: async (data: Partial<EntityType>) => {
    const response = await api.post("/entityType/edit", data);
    return response.data;
  },

  removeEntityType: async (id: string) => {
    return await api.post("/entityType/remove", { id });
  },

  activateEntityType: async (id: string) => {
    return await api.post("/entityType/activate", { id });
  },

  deactivateEntityType: async (id: string) => {
    return await api.post("/entityType/deactivate", { id });
  },
};
